module.exports = __webpack_public_path__ + "static/media/jetson_one_render_20.3e00bebd.jpg";